export const containerTheme = {
  baseStyle: {
    w: ['full', 'full', 'container.md', 'container.lg'],
    mx: 'auto',
    // TODO: deviation from the design system
    maxW: { base: 'none', lg: '868px', xl: '1246px' }, // to override chakra-ui container maxW
    px: [3, 3, 4, 6],
  },
};
